import 'antd/lib/style/index.less' // antd core styles
import './components/kit/vendors/antd/themes/default.less' // default theme antd components
import './components/kit/vendors/antd/themes/dark.less' // dark theme antd components
import './global.scss' // app & third-party component styles
import React from 'react'
import ReactDOM from 'react-dom'
import { createHashHistory } from 'history'
import { createStore, applyMiddleware, compose } from 'redux'
import { Provider } from 'react-redux'
import { logger } from 'redux-logger'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Inspector } from 'react-dev-inspector'
// eslint-disable-next-line import/no-extraneous-dependencies
import launchEditorEndpoint from 'react-dev-utils/launchEditorEndpoint'
import createSagaMiddleware from 'redux-saga'
import { routerMiddleware } from 'connected-react-router'
import axios from 'axios'
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { create as analyticsInit, capturePageView } from './config/analytics'
import reducers from './redux/reducers'
import sagas from './redux/sagas'
import Localization from './localization'
import Router from './router'
import * as serviceWorker from './serviceWorker'
import {Creators} from './redux/modals'
import {ItemCodeContextProvider} from "./core/contexts/itemCodes";
import apiClient from "./services/axios";
// import {getUrl} from "./services/api";
import {AuthProvider} from "./core/contexts/auth/AuthProvider";
import {getUrl} from "./services/api";

Sentry.init({
  dsn: "https://9701d8fe0b10460b955be12d0d46fc47@o379141.ingest.sentry.io/5203504",
  integrations: [new BrowserTracing()],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});


const history = createHashHistory()


if(process.env.NODE_ENV !== 'development'){
  analyticsInit()
  history.listen(() => capturePageView())
}

// middlewared


console.log("version", {
  version: process.env.REACT_APP_VERSION,
  api: process.env.REACT_APP_API_URL,
})

const sagaMiddleware = createSagaMiddleware()
const routeMiddleware = routerMiddleware(history)
const middlewares = [sagaMiddleware, routeMiddleware]
if (process.env.NODE_ENV === 'development') {
   middlewares.push(logger)
}
const store = createStore(reducers(history), compose(applyMiddleware(...middlewares)))
sagaMiddleware.run(sagas)

const mfName = "performa2"

// render micro frontend function
window[`render${mfName}`] = (containerId, lhistory) => {
  ReactDOM.render(
    <Provider store={store}>
      <Localization>
        <Router history={lhistory} />
      </Localization>
    </Provider>,
    document.getElementById(containerId)
  );
  serviceWorker.unregister();
};

// unmount micro frontend function
window[`unmount${mfName}`] = containerId => {
  ReactDOM.unmountComponentAtNode(document.getElementById(containerId));
};

const InspectorWrapper = process.env.NODE_ENV === 'development'
  ? Inspector
  : React.Fragment

const getDebugSource = (fiber, result=[]) => {
  if(fiber._debugSource){
    result.push(fiber._debugSource)
  }
  if(fiber._debugOwner && result.length < 11){
    return getDebugSource(fiber._debugOwner,result)
  }
  return result
}
const gotoEditor = (source) => {
  if (!source) return

  const {
    lineNumber,
    columnNumber,
    relativePath,
    absolutePath,
  } = source

  const isRelative = Boolean(relativePath)

  const launchParams = {
    fileName: isRelative ? relativePath : absolutePath,
    lineNumber,
    colNumber: columnNumber,
  }

  /**
   * api in 'react-dev-inspector/plugins/webpack/middlewares' launchEditorMiddleware
   */
  const apiRoute = isRelative
    ? `${launchEditorEndpoint}/relative`
    : launchEditorEndpoint
  axios.get(`${apiRoute}`,{params:launchParams})
}
// Mount to root if it is not a micro frontend
if (!document.getElementById(`${mfName}-container`)) {
  const getItemCodes = (type,options) =>
    // "api/item_code_views"
    apiClient.get(getUrl('/api/item_codes'),{params: {tipo: type, ...options}}).
    then(res => res.data['hydra:member']);
  ReactDOM.render(
    <Provider store={store}>
      <Localization>
        <InspectorWrapper
          // props docs see:
          // https://github.com/zthxxx/react-dev-inspector#inspector-component-props
          keys={['control', 'shift', 'command', 'c']}
          disableLaunchEditor
          onHoverElement={(params) => { console.log('onHoverElement', params)}}
          onClickElement={(params) => {
            // const getSourcePaths =
            const sourceMap = getDebugSource(params.fiber,[])

            store.dispatch(Creators.open("openEditor",{
              sourceMap,
              onClick: (selected)=> {
                gotoEditor({
                  lineNumber: selected.lineNumber,
                  columnNumber: selected.columnNumber,
                  relativePath: selected.relativePath,
                  absolutePath: selected.fileName
                })
              }
            }))
          }}
        >
          <AuthProvider>
            <ItemCodeContextProvider
              fetchFn={getItemCodes}
              groupBy="tipo"
            >
              <Router history={history} />
            </ItemCodeContextProvider>
          </AuthProvider>
        </InspectorWrapper>
      </Localization>
    </Provider>,
    document.getElementById('root'),
  )

}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
export { store, history }
